// extracted by mini-css-extract-plugin
export default {"noise":"Noise_noise__oWF+b","scaleWrapper":"Noise_scaleWrapper__lZ7tx","noiseSrc":"Noise_noiseSrc__4BLde","noiseFX":"Noise_noiseFX__h-oad"};